import React, { useMemo, useRef, useState } from "react";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import Grid from "../../../../atoms/Grid";
import { Button, Card, Col, Row, message } from "antd";
import { AgGridReactProps } from "ag-grid-react";
import { useClearCheque } from "./hook/useClearCheque";
interface ChequeRow {
  id: string;
  receiptNo: string;
  chequeNo: string;
  chequeDate: string;
  amount: number;
  data?: any;
  totalAmount?: number;
}

const ChequeClearModal = ({ data, onSuccess, setVisible }) => {
  const { clearCheque, loading, error } = useClearCheque();
  const [selectedPdcIds, setSelectedPdcIds] = useState<string[]>([]);

  let isPartial = data?.params?.data?.paymentMethodType?.toLowerCase() === "partial";

  const chequeRowData = isPartial ? data?.params?.data?.subPdcs : [data?.params?.data];

  const filterCheques =
    chequeRowData.filter(
      (pdc: any) => pdc?.status?.toLowerCase() === "paid" && pdc.paymentReceiptId && !pdc?.isCleared
    ) || [];
  const chequeColumnDefs: ColDef<ChequeRow>[] = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      flex: 1,
    },
    {
      headerName: "RECEIPT NO",
      field: "receiptNo",
      maxWidth: 150,
      width: 150,
    },
    {
      headerName: "CHEQUE NO",
      field: "documentNo",
      minWidth: 150,
      width: 150,
    },

    {
      headerName: "CHEQUE DATE",
      field: "paidDate",
      minWidth: 160,
      width: 160,
      valueFormatter: (params) => (params.value ? dayjs(params.value).format("DD-MM-YYYY") : ""),
    },
    {
      headerName: "AMOUNT",
      maxWidth: 150,
      width: 150,
      type: "numericColumn",
      valueGetter: (params) => params.data?.totalAmount ?? params.data?.amount ?? 0,
      valueFormatter: (params) =>
        `AED ${Number(params.value || 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
  ];

  const onSelectionChanged: AgGridReactProps["onSelectionChanged"] = ({ api }) => {
    const pdcIds = [];

    for (const node of api.getSelectedNodes()) {
      const { chequeStatus, pdcId, subPdcId } = node?.data || {};
      if (isPartial && subPdcId) pdcIds.push({ subPdcId });
      else pdcIds.push(pdcId);
    }
    if (pdcIds.length > 0) setSelectedPdcIds(pdcIds);
    else setSelectedPdcIds([]);
  };

  const handleMarkAsCleared = async () => {
    try {
      let payload: any = {
        leaseId: data?.params?.data?.leaseId,
        pdcId: data?.params?.data?.pdcId,
        isCleared: true,
      };

      if (isPartial) {
        payload["subPdc"] = selectedPdcIds;
      }
      const result = await clearCheque(payload);

      if (result?.success) {
        message.success("Cheque cleared successfully");
        onSuccess();
      }
    } catch (err) {
      message?.error(error?.response?.data?.error || "Failed to update invoice");
      // console.error(err,'asdasdsadasdsa');
    }
  };

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <Grid
        data={isPartial ? filterCheques : chequeRowData}
        columns={chequeColumnDefs}
        rowSelection="multiple"
        className="mark-clear-grid"
        // suppressRowClickSelection
        // domLayout="autoHeight"
        height={filterCheques?.length > 1 ? filterCheques?.length * 80 + "px" : "120px"}
        onSelectionChanged={onSelectionChanged}
        getRowId={(params) => params.data.id}
      />

      <Row
        gutter={24}
        justify="space-between"
        style={{ marginTop: "10px", marginBottom: "15px", marginLeft: "5px", marginRight: "5px" }}
      >
        <Col>
          <Button className="ef-discard-btn" onClick={() => setVisible({ status: false, index: 0 })}>
            Back
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            className="ef-approve-btn"
            disabled={selectedPdcIds?.length === 0 || loading}
            onClick={() => handleMarkAsCleared()}
          >
            {loading ? "loading..." : "Mark as Cleared"}
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default ChequeClearModal;
